<ng-template #contentContactModal let-modal>
  <div class="modal-header container border-0 pt-3">
    <button type="button" class="btn-close btn-close-black me-1" aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <h4 class="text-uppercase text-center fw-normal">Contacter {{ami?.name}}</h4>
    <div class="row g-2 text-white">

      <form #contactForm="ngForm" class="mesInfos-content contact-form text-black" novalidate>
        <div class="inner-form form-bloc">
          <div *ngIf="!user">

            <div class="row my-3">
              <div class="col-sm-6 mb-1">
                <label class="form-label" for="contact-nom">Nom *</label>
                <input id="contact-nom" [(ngModel)]="formContact.name" name="nom" type="text" class="form-control"
                  placeholder="Ex : DUPONT" required />
                <span *ngIf="formContact.name === ''"><i class="icon-close"></i> &nbsp;Champ obligatoire</span>
              </div>
              <div class="col-sm-6 mb-1">
                <label class="form-label" for="contact-prenom">Prénom *</label>
                <input id="contact-prenom" [(ngModel)]="formContact.lastname" name="prenom" type="text" class="form-control"
                  placeholder="Ex : Marc" required />
                <span *ngIf="formContact.lastname === ''"><i class="icon-close"></i> &nbsp;Champ obligatoire</span>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-6 mb-1">
                <label class="form-label" for="contact-telephone">Téléphone *</label>
                <input id="contact-telephone" [(ngModel)]="formContact.phone" name="telephone" type="tel" class="form-control"
                  placeholder="Ex : 0602030405" maxlength="10" required isNumber />
                <span *ngIf="formContact.phone === ''"><i class="icon-close"></i> &nbsp;Champ obligatoire</span>
              </div>
              <div class="col-sm-6 mb-1">
                <label class="form-label" for="contact-email">Email *</label>
                <input id="contact-email" [(ngModel)]="formContact.email" name="email" type="email" class="form-control"
                  placeholder="Ex : marc.dupont@mail.com" pattern="[^@\s]+@[^@\s]+\.[^@\s]+" required
                  (blur)="checkValidEmail(formContact.email)" (keyup)="checkValidEmail(formContact.email)" />
                <span><i class="icon-close"></i> &nbsp; {{invalidOrEmpty}}</span>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-12">
              <label class="form-label" for="contact-message">Votre message *</label>
              <textarea id="contact-message" [(ngModel)]="formContact.message" name="message" cols="30" rows="3" class="form-control text-area"
                placeholder="Précisez votre demande en quelques mots..." required></textarea>
              <span *ngIf="formContact.message === ''"><i class="icon-close"></i> &nbsp;Champ obligatoire</span>
            </div>
            </div>

          </div>

          <div class="my-4">
            <div class="py-3 form-check">
              <input class="form-check-input" type="checkbox" id="accept-rgpdoffre" name="rgpdoffre"
                [(ngModel)]="formContact.rgpdoffre" [checked]="formContact.rgpdoffre" required>
              <label class="form-check-label" for="accept-rgpdoffre">
                * J'accepte que mes données personnelles soient traitées par THE DOOR MAN pour
                donner suite à ma demande.
              </label>
            </div>
          </div>
          <fieldset class="field-item field-checkbox field-rgpd">
            <!-- <ngx-recaptcha2 [siteKey]="siteKey" (success)="handleSuccess($event)" (expire)="handleExpire()"
                            name="recaptcha" [(ngModel)]="formContact.recaptcha">
                        </ngx-recaptcha2> -->
          </fieldset>
          <div class="my-3">
            <button class="btn btn-gold px-4 py-2" type="submit" (click)="onSendContact(formContact, contactForm, id)"
              [disabled]="contactForm.invalid || !validRecaptcha || launchedRequest">envoyer</button>
          </div>
          <div class="text-center bottom-form">
            <span class="mandatory">* &nbsp;Champs obligatoires</span>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<button *ngIf="!txtButton" type="button" class="btn btn-gold mb-2 me-2"
  (click)="openVerticallyCentered(contentContactModal)">Contact</button>

<button *ngIf="txtButton" type="button" class="btn btn-gold mb-2 me-2" [ngClass]="{'w-100': full == 'true'}"
  (click)="openVerticallyCentered(contentContactModal)">{{txtButton}}</button>
